import { Typography } from "@bigbinary/neeto-atoms";
import classnames from "classnames";
import { dateFormat } from "neetocommons/utils";

import { ACTIONS, AUDIT_ICON_MAP, INTEGRATION_ICON_MAP } from "./constants";
import { constructAuditLogText, transformAction } from "./utils";

const Card = ({
  auditLog,
  countriesMap,
  index,
  permissionsMap,
  totalCount,
}) => {
  const { key, metadata, performer, updatedAt } = auditLog;

  const action = transformAction(key);
  const performedBy = performer?.name || "";
  const performedAt = dateFormat.dateTime(updatedAt);

  const auditText = constructAuditLogText({
    countriesMap,
    action,
    performedBy,
    permissionsMap,
    ...metadata,
  });

  const isIntegrationAction =
    action === ACTIONS.INTEGRATION_CONNECTED ||
    action === ACTIONS.INTEGRATION_DISCONNECTED ||
    action === ACTIONS.INTEGRATION_DISCONNECTED_BY_PROVIDER;

  const Icon = isIntegrationAction
    ? INTEGRATION_ICON_MAP[metadata?.integrationName] || AUDIT_ICON_MAP[action]
    : AUDIT_ICON_MAP[action];

  return (
    <div
      data-testid="audit-log-card"
      className={classnames(
        "border-border flex w-full items-start gap-x-3 border-r border-b border-l px-4 py-3",
        {
          "rounded-t-md border-t": index === 0,
          "rounded-b-md": index === totalCount - 1,
        }
      )}
    >
      <div className="bg-muted neeto-ui-rounded-full mt-0.5 flex size-9 shrink-0 items-center justify-center">
        <Icon className="text-muted-foreground" size={18} />
      </div>
      <div
        className="flex min-w-0 flex-col gap-y-1"
        data-testid="audit-log-content"
      >
        <Typography asChild variant="body2">
          <span className="leading-snug" data-testid="audit-log-text">
            {auditText}
          </span>
        </Typography>
        <span
          className="text-muted-foreground text-xs"
          data-testid="audit-log-timestamp"
        >
          {performedAt}
        </span>
      </div>
    </div>
  );
};

export default Card;
